export const SUBMIT_ADMIN_LOGIN_BEGIN = "SUBMIT_ADMIN_LOGIN_BEGIN";
export const SUBMIT_ADMIN_LOGIN_SUCCESS = "SUBMIT_ADMIN_LOGIN_SUCCESS";
export const SUBMIT_ADMIN_LOGIN_FAILURE = "SUBMIT_ADMIN_LOGIN_FAILURE";
export const RESET_SUBMIT_ADMIN_LOGIN = "RESET_SUBMIT_ADMIN_LOGIN";
